import customFetch from "../fetch/custom";
import { env } from "~/env";
import { type IGetCampaignsResult, type IGetCampaignsInput } from "./types";

const baseUrl = env.NEXT_PUBLIC_CAMPAIGN_SERVICE_URL;

export function getCampaigns({ queryParams }: IGetCampaignsInput) {
  const url = new URL(`${baseUrl}/public/campaign/list`);

  if (queryParams) {
    let key: keyof NonNullable<IGetCampaignsInput["queryParams"]>;
    for (key in queryParams) {
      const value = queryParams[key];
      if (value) {
        url.searchParams.append(key, String(value));
      }
    }
  }

  return customFetch<IGetCampaignsResult["data"]>(url.toString(), {
    name: "get campaigns",
    next: { revalidate: 300 },
  });
}
